import React from 'react';
import { Skeleton } from '@mui/material';

import './mobile-header-skeleton-style.scss';

import Logo from "@src/imagesNew/logo/maccaron-logo.jpg";

import { SKELETON_COLOR } from "@src/utils/constants";

interface IProps {
  isMain: boolean;
  hasBorderBottom: boolean;
}

const MobileHeaderSkeleton = ({ isMain, hasBorderBottom }: IProps) => {

  return (
    <div id='mobile-header-skeleton-wrapper' className={`${hasBorderBottom ? "custom-border" : ''}`}>
      <div className='content-wrapper'>
        {
          isMain ?
            <img src={Logo} alt="logo" width="120" />
            : <Skeleton variant="rectangular" width={24} height={24} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 4 }} />
        }

        <div className='right-area'>
          <Skeleton variant="rectangular" width={24} height={24} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 4 }} />
          <Skeleton variant="rectangular" width={24} height={24} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 4 }} />
          {!isMain && <Skeleton variant="rectangular" width={24} height={24} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 4 }} />}
        </div>
      </div>

      {
        isMain && <Skeleton variant="rectangular" width="100%" height={44} style={{ backgroundColor: SKELETON_COLOR, paddingRight: 16, paddingLeft: 16, borderRadius: 4 }} />
      }
    </div>

  );
};

export default MobileHeaderSkeleton;
